import './style.scss';

import { GetMsgResCode, TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { handleRequest } from '@/utils';
import { addDialogue, updateDialogueInfo } from '@/utils/sessionUtils';
import { addUserMsg, postChatMsg, reviewChatEndText } from '@/utils/agent';
import { handleClickHistoryButton } from '@/utils/tools';
import { inject, observer } from 'mobx-react';

import Msg from '@/components/Msg';
import React from 'react';
import arrowDownImage from '@/assets/img/arrow_down@2x.png';
import clsx from 'classnames';
import { tracker } from '@/utils/tracking';
import { getChildInject, isNum } from '@/utils/instantLoaded/tools';

const PREFIX = 'hot-questions-container';

// 目前有两种情况
// 1. 带有category的HQ
// 2. 只有HQ
@tracker
@inject(getChildInject('initStore', 'agentStore'))
@observer
export default class HotQuestions extends React.PureComponent {

  static defaultProps = {
    msgContent: '',
    // 是不是带order的hot question
    isOrderCard: false,
    // stores
    initStore: {},
    agentStore: {},
    hotQuestionList: []
  };

  constructor(props) {
    super(props);
    this.trackingname = TRACKING_TYPE.HOTQUESTION;
    this.trackingnameCat = TRACKING_TYPE.HOTQUESTIONCAT;
    this.state = {
      hotQuestionList: props.hotQuestionList
    };
  }

  changeHotQuestionList = hotQuestionList => {
    this.setState({ hotQuestionList });
  }

  handleQuestionClick = (question, index) => () => {
    const { initStore, isOrderCard, isHistory, historySessionId } = this.props;
    const { hotQuestionList } = this.state;
    const copyList = hotQuestionList.map(question => ({ ...question }));
    const currentQuestion = copyList[index];
    const currentStatus = currentQuestion.isOpen;

    if (currentStatus) {
      // 关闭目标cat
      currentQuestion.isOpen = false;
    } else {
      // 点击埋点 - 仅在打开时发送
      this.trackingHandler(this.trackingnameCat, {
        question_catid: question.category_id,
        chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
        is_order_card: isOrderCard,
        if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME
      });

      // 先收起其他cat，再展开目标cat
      copyList.forEach(item => {
        item.isOpen = false;
      });
      currentQuestion.isOpen = true;
    }

    this.changeHotQuestionList(copyList);
  };

  handleSubQuestionClick = (subQuestion, index, parentIndex) => async () => {
    const { initStore, agentStore, isOrderCard, isHistory, historySessionId } = this.props;
    const { hotQuestionList } = this.state;

    // 点击埋点
    this.trackingHandler(this.trackingname, {
      content: subQuestion.question_name,
      question_id: subQuestion.question_id,
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      is_order_card: isOrderCard,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      location: this.getSubQuestionIndex(parentIndex, index)
    });

    if (isHistory) {
      handleClickHistoryButton();
      return;
    }

    try {
      // 点击后，文字灰显
      const copyList = hotQuestionList.slice();
      let currentQuestion;

      if (parentIndex !== undefined) {
        currentQuestion = copyList[parentIndex].children[index];
      } else {
        currentQuestion = copyList[index];
      }

      currentQuestion.beenChoosen = true;
      this.changeHotQuestionList(copyList);
    } catch (err) {
      // do nothing
    }

    // 在agent过程中，走agent逻辑
    if (agentStore.inAgent) {
      const curPos = addUserMsg({
        from: 'user',
        type: 'Msg',
        data: {
          content: subQuestion.question_name,
          // loading: true
          requesting: true
        }
      });

      // 未成功输入
      if (!isNum(curPos)) {
        return;
      }

      // 如果会话已结束
      if (agentStore.agentEndedReason) {
        // 回显agent离开文案
        reviewChatEndText();
        agentStore.UPDATE_AGENT_DATA_ITEM({
          loading: false,
          error: true,
          requesting: false
        }, curPos);
        return;
      }
      // in Queue 不发请求
      if (agentStore.position) {
        agentStore.UPDATE_AGENT_DATA_ITEM({
          loading: false,
          requesting: false
        }, curPos);
      } else {
        const {code: resCode} = await postChatMsg({
          text: subQuestion.question_name
        });
        if (resCode === GetMsgResCode.SUCCESS) {
          agentStore.UPDATE_AGENT_DATA_ITEM({
            loading: false,
            requesting: false
          }, curPos);
        } else {
          agentStore.UPDATE_AGENT_DATA_ITEM({
            loading: false,
            error: true,
            requesting: false
          }, curPos);
        }
      }
    } else {
      // 走ChatBot逻辑
      const curPos = addDialogue({
        from: 'user',
        type: 'Msg',
        data: {
          content: subQuestion.question_name
        }
      });
      if (isNum(curPos)) {
        // 当type为1时，需要将后端放在callback中的参数传回
        const params = subQuestion.type === 1
          ? { ...(subQuestion.query_callback || {}) }
          : {
            session_id: initStore.sessionId,
            question_id: subQuestion.question_id
          };

        handleRequest('getHotQuestionAnswer', params, { curPos }).then(res => {
          res && updateDialogueInfo({
            dialogueId: res.dialogue_id,
            dialogueType: res.dialogue_type
          }, curPos);
        });
      }
    }
  };

  // 埋点用 - 点击事件
  trackingHandler = (trackingname, data) => {
    this.props.tracker.click({
      trackingname,
      data
    });
  }

  generateQuestion = (question, index) => {
    return (
      <div
        className='question-container'
        key={`question-${index}`}
      >
        <div className="question" onClick={this.handleQuestionClick(question, index)}>
          <span>{question.category_name}</span>
          <img className={`arrow-down${question.isOpen ? ' reverse' : ''}`} src={arrowDownImage}></img>
        </div>
        <div className={`sub-question-container${!question.isOpen ? ' hide' : ''}`}>
          {
            question.children.map((subQuestion, subIndex) => {
              return this.generateSubQuestion(subQuestion, subIndex, index);
            })
          }
        </div>
      </div>
    );
  };

  getSubQuestionIndex = (parentIndex, selfIndex) => {
    if (parentIndex === undefined) { return selfIndex; }

    const { hotQuestionList } = this.state;

    let currentIndex = selfIndex;

    for (let i = 0; i < parentIndex; i++) {
      currentIndex += hotQuestionList[parentIndex].children.length;
    }

    return currentIndex;
  }

  // 如果没有parentIndex 说明没有category
  generateSubQuestion = (question, index, parentIndex) => {
    const { disabledBtn } = this.props;

    return (
      <div
        className={clsx('sub-question', {
          grey: question.beenChoosen,
          disabled: disabledBtn
        })}
        key={`sub-question-${index}`}
        onClick={this.handleSubQuestionClick(question, index, parentIndex)}
      >
        {question.question_name}
      </div>
    );
  };

  render() {
    const msgContent = this.props.msgContent;
    const { hotQuestionList } = this.state;

    return <div className={PREFIX}>
      <Msg content={msgContent} />
      <div className="questions">
        {
          (hotQuestionList || []).map((question, index) => {
            if (question.children) {
              return this.generateQuestion(question, index);
            }
            return this.generateSubQuestion(question, index);
          })
        }
      </div>
    </div >;
  }
}
